import { render, staticRenderFns } from "./a-modal.vue?vue&type=template&id=7078bb0c&"
import script from "./a-modal.vue?vue&type=script&lang=js&"
export * from "./a-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports